import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Box } from "lucide-react";
import "@/App.css";

const TERMS = [
  { head: "Made to order", body: "Every Biswas3D statue is custom-sculpted from your photos and printed in PLA specifically for you. Once an order is placed and paid, it cannot be cancelled, returned or refunded." },
  { head: "Handcrafted variance", body: "3D printing and hand-finishing are craft processes. The finished statue can differ from your reference photo by up to 30% in likeness, colour and surface detail. Minor layer lines and small imperfections are a normal part of a handcrafted print, not defects." },
  { head: "Confirmation before printing", body: "We call you on your given phone number after payment to confirm photos, size and details. Printing starts only after this confirmation call. If we cannot reach you after repeated attempts, your order may be delayed." },
  { head: "Photos you share", body: "Clear, front-facing, well-lit photos give the best likeness. Blurry, dark or side-angle photos may reduce accuracy. You confirm you have the right to share the photos you upload." },
  { head: "Pricing and payment", body: "Prices shown on the website are final (10 cm: Single ₹1,000, Couple ₹1,700, Family ₹3,000; 20 cm pieces are double). Payment is collected securely via Razorpay at the time of ordering." },
  { head: "Delivery", body: "Delivery or pickup timelines are shared on the confirmation call. Delays can occur during high order volumes; we will keep you informed on WhatsApp or phone." },
  { head: "Contact", body: "Biswas3D, Room No 413, Avinash Lifestyle Empressa, Kota, Raipur, Chhattisgarh 492001. Call or WhatsApp: +91 9343920661, +91 8602955165." },
];

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="site-shell order-page">
      <div className="noise" aria-hidden="true" />
      <nav className="order-topbar" data-testid="terms-page-nav">
        <Link to="/" className="brand" style={{ textDecoration: "none" }} data-testid="terms-brand-link"><span className="brand-mark"><Box size={18} strokeWidth={2.5} /></span><span>Biswas<span className="cyan">3D</span></span></Link>
        <Link to="/" className="map-link" data-testid="terms-back-link"><ArrowLeft size={16} /> Back to site</Link>
      </nav>
      <main className="terms-page section-wrap" data-testid="terms-page">
        <p className="eyebrow">The fine print</p>
        <h1 className="terms-title">Terms &amp; Conditions</h1>
        <p className="terms-intro">These terms apply to every order placed on the Biswas3D website. By ticking the box at checkout and paying, you agree to all of the following.</p>
        <ol className="terms-page-list" data-testid="terms-list">
          {TERMS.map((t, i) => (
            <li key={i} data-testid={`terms-item-${i + 1}`}><strong>{t.head}.</strong> {t.body}</li>
          ))}
        </ol>
        <Link to="/order" className="button button-primary" data-testid="terms-order-button" style={{ marginTop: 36 }}>I understand — place my order</Link>
      </main>
    </div>
  );
}
